import { isNull } from '@/shared/utils/utils';
import { IMailWizzEntity } from '../common/mailwizz-entity';
import { INamedEntity } from '../common/named-entity';

export class TrackingDomain implements IMailWizzEntity, INamedEntity {
    name: string;
    mailWizzEntityId: number;
    active: boolean;

    static parseJson(json: any): TrackingDomain {
        if (isNull(json)) { return null; }

        const { mailWizzEntityId, ...rest} = json

        const deliveryServer = Object.assign(new TrackingDomain(), rest)
        deliveryServer.mailWizzEntityId = parseInt(mailWizzEntityId)

        return deliveryServer;
    }
}